<template>
	<view class="activity-item">
		<view class="activity-message">
			<image src="@/static/uni.png" mode=""></image>
			<view class="message-container">
				<view class="merchant-title">白雪公主</view>
				<view class="activity-option">
					门店评价  4星  | 店内环境  4星  |  服务态度  4星
				</view>
			</view>
		</view>
		<view class="comment-message">
			<uni-grid :column="4" :highlight="true" :showBorder="false" @change="change">
				<uni-grid-item v-for="(item, index) in 9" :index="index" :key="index">
					<view class="grid-item-box" style="background-color: #fff; text-align: center;">
						<image src="@/static/uni.png" style="width: 156rpx; height: 156rpx;" mode=""></image>
					</view>
				</uni-grid-item>
			</uni-grid>
			<view class="comment-content">
				咖啡芝士蛋糕口感丰富。店铺环境好，和朋友一起喝个下午茶
			</view>
		</view>
		<view class="comment-time">发布于2023-03-12 19:00</view>
	</view>
</template>

<script>
	export default {
		name:"commentItem",
		props: {
			itme: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				change() {}
			};
		}
	}
</script>

<style lang="scss" scoped>
.activity-item {
	background-color: #fff;
	padding: 28rpx 32rpx;
	border-bottom: 10px solid #f7f7f7;
	// height: 200rpx;
	.activity-message {
		display: flex;
		image {
			width: 72rpx;
			height: 72rpx;
			border-radius: 50%;
			margin-right: 20rpx;
		}
		.message-container {
			flex: 1;
			.merchant-title {
				height: 28rpx;
				font-size: 28rpx;
				font-weight: 400;
				color: #222222;
				line-height: 28rpx;
			}
			.activity-option {
				margin-top: 20rpx;
				height: 24rpx;
				font-size: 24rpx;
				font-weight: 400;
				color: #666666;
				line-height: 24rpx;
			}
			
		}
		.activity-status {
			ont-size: 26rpx;
			font-weight: 400;
			color: #D20A0A;
			line-height: 26rpx;
		}
	}
	.comment-message {
		margin-top: 28rpx;
	}
	.comment-content {
		margin-top: 20rpx;
		font-size: 30rpx;
		font-weight: 400;
		color: #222222;
		line-height: 44rpx;
	}
	.comment-time {
		margin-top: 24rpx;
		height: 24rpx;
		font-size: 24rpx;
		font-weight: 400;
		color: #999999;
		line-height: 24rpx;
	}
}
</style>